import React from 'react';

const Label = ({label}) => (
    <div className="config-label display-inline">
        {label}
    </div>
);

export default Label;